import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/AccountSettingsTypes'

export const updateSendForHumanReviewSetting = createAction(
  types.UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING,
)
export const updateSendForHumanReviewSettingFailed = createAction(
  types.UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_FAILED,
)
export const updateSendForHumanReviewSettingSucceed = createAction(
  types.UPDATE_SEND_FOR_HUMAN_REVIEW_SETTING_SUCCEEDED,
)
